import React, {Component} from 'react';

import {Form, Row, Col, Button, Upload, Icon,Modal, message} from 'antd';

import moment from 'moment';

import reqwest from 'reqwest';

import Modals from './../Modal';

import org from './../org';
import Input from './../Input';
import TextArea from './../TextArea';
import DatePicker from './../DatePicker';

import fetch from './../../services/fetch';
const FormItem = Form.Item;

class UploadModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            file: [],
            files: [],
            domain: {
                name: '',
                folderId: props.folderId,
                fileNumber:'',
                publishOrgId:'',
                publishDate: '',
                fileDesc:'',
                file: '',
                files: []
            }
        };

        this.domain = {
            name: '',
            folderId: props.folderId,
            fileNumber:'',
            publishOrgId:'',
            publishDate: '',
            fileDesc:'',
            file: '',
            files: []
        }
    }

    handleSumbit() {

        event.preventDefault();

        this.props.form.validateFields((error, values) => {
            if(!error) {
                const domain = this.domain;

                const formData = new FormData();

                formData.append('name', domain.name);
                formData.append('folderId', domain.folderId);
                formData.append('fileNumber', domain.fileNumber);
                formData.append('publishOrgId', domain.publishOrgId);
                formData.append('pubDate', moment(new Date(domain.publishDate)).format('YYYY-MM-DD'));
                formData.append('fileDesc', domain.fileDesc);
                formData.append('file', this.state.file[0]);

                reqwest({
                    url: fetch.base+'file/manage/upload',
                    method: 'post',
                    processData: false,
                    data: formData,
                    success: (response) => {
                        this.setState({
                            file: [],
                            uploading: false,
                        });
                        const data = JSON.parse(response);
                        if(data.code === 200) {
                            Modal.success({
                                title: '文件上传',
                                content: '文件上传成功！',
                                onOk:() => {
                                    //this.props.form.setFieldsValue({publishDate: ''});
                                }
                            });
                        } else {
                            Modal.error({
                                title: '文件上传',
                                content: data.message,
                                onOk:() => {
                                    //this.props.form.setFieldsValue({publishDate: ''});
                                }
                            });
                        }
                        this.handleCancel();
                    },
                    error: (response) => {
                        const data = JSON.parse(response);
                        this.setState({
                            uploading: false,
                        });
                        message.error(data.message);
                        this.handleCancel();
                    },
                });
            }
        });
        
    }

    componentWillReceiveProps(nextProps) {
        const folderId = nextProps.folderId;

        if(folderId ) {
            this.domain = Object.assign({}, this.domain, {folderId});
        }
        
    }

    handleChange(data) {
        this.domain = Object.assign({}, this.domain, data);
        this.setState({
            domain: this.domain
        })
    }
    
    handleCancel() {
        this.props.handleCancel();
    }

    onSubmit(event) {
        
    }

    onRemove(file) {

    }

    beforeUpload(file) {
        this.setState(state => ({
            file: [file],
        }));
        return false;
    }

    beforeUploads(file) {
        this.setState(state => ({
            files: [...state.files, file],
        }));
        return false;
    }

    render() {
        const file = this.state.file;
        const props  = this.props;
        const {getFieldDecorator} = props.form;

        return (
            <Modals title="上传文件" width="600px" visible={this.props.visible}  handleSumbit={this.handleSumbit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
                <Form layout="inline"
                onSubmit={this.onSubmit.bind(this)}>
                    <div className="root-form-body">
                        <Row>
                            <Col span="18">
                                <FormItem label="主文件上传">
                                    <Upload beforeUpload={this.beforeUpload.bind(this)} onRemove={this.onRemove.bind(this)} fileList={file}>
                                        <Button>
                                        <Icon type="upload" /> 选择文件
                                        </Button>
                                    </Upload>
                                </FormItem>
                            </Col>
                            <Col span="6"></Col>
                        </Row>
                        <Row>
                            <Col span="18"><Input name="name" label="文件名称" getFieldDecorator={getFieldDecorator} value={this.state.domain.name} handleChange={this.handleChange.bind(this)} /></Col>
                            <Col span="6"></Col>
                        </Row>
                        <Row>
                            <Col span="18"><Input name="fileNumber" label="文件字号" getFieldDecorator={getFieldDecorator} value={this.state.domain.fileNumber} handleChange={this.handleChange.bind(this)} /></Col>
                            <Col span="6"></Col>
                        </Row>

                        <Row>
                            <Col span="18"><org.Name getFieldDecorator={getFieldDecorator} name="publishOrgId" label="部门" value={this.state.domain.publishOrgId} handleChange={(data) => {
                                this.handleChange({
                                    publishOrgId: data.orgId
                                });
                            }} /></Col>
                            <Col span="6"></Col>
                        </Row>

                        <Row>
                            <Col span="18"><DatePicker getFieldDecorator={getFieldDecorator} name="publishDate" label="发布时间" value={this.state.domain.publishDate} handleChange={this.handleChange.bind(this)} /></Col>
                            <Col span="6"></Col>
                        </Row>

                        <Row>
                            <Col span="24"><TextArea name="fileDesc" label="描述" value={this.state.domain.fileDesc} handleChange={this.handleChange.bind(this)} /></Col>
                            <Col span="0"></Col>
                        </Row>
                    </div>
                </Form>
            </Modals>
        )
    }
}

export default Form.create()(UploadModal);